export default __webpack_public_path__ + "static/media/AVR.cc0e4b05.jpg";